export const removeTime = (timestamp) => {
    return timestamp.split('T')[0];
};
